import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "truncate-text",
  class TruncateText extends WYATTElement {
    connectedCallback() {
      const content = this.querySelector("[data-truncate-text-content]");

      const observer = new ResizeObserver((entries) => {
        entries.forEach(() => {
          this.setAttribute(
            "truncated",
            content.scrollHeight > content.offsetHeight,
          );
        });
      });

      observer.observe(content);
    }
  },
);
